import React from 'react'
import { Defs, G, Line, Path, Pattern } from 'react-native-svg'
import { TerritoryInteriorMask } from './TerritoryInteriorMask'

interface SourceHatchLayerProps {
  shape?: string
  regionShape?: string
  territoryId: string
  clipNS: string
  /** Yellow's chosen player color needs dark lines; every other color uses light. */
  dark: boolean
  unitsPerPixel: number
  borderInset: number
  regionBorderInset: number
}

/** Static source marker, above map art but below glows, results and troop numbers. */
export function SourceHatchLayer({ shape, regionShape, territoryId, clipNS, dark, unitsPerPixel,
  borderInset, regionBorderInset }: SourceHatchLayerProps) {
  if (!shape) return null
  const patternId = `${clipNS}source-hatch`
  const maskId = `${clipNS}source-interior`
  const gap = 8 * unitsPerPixel
  return (
    <G pointerEvents="none">
      <Defs>
        <Pattern id={patternId} width={gap} height={gap}
          patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
          <Line x1={gap / 2} y1={0} x2={gap / 2} y2={gap}
            stroke={dark ? '#332600' : '#ffffff'} strokeWidth={1.25 * unitsPerPixel}
            strokeOpacity={dark ? 0.4 : 0.28} />
        </Pattern>
        <TerritoryInteriorMask id={maskId} shape={shape} regionShape={regionShape}
          borderInset={borderInset} regionBorderInset={regionBorderInset} />
      </Defs>
      <Path testID="source-selection-hatch" d={shape} fill={`url(#${patternId})`}
        fillRule="evenodd" mask={`url(#${maskId})`} clipPath={`url(#${clipNS}clip-${territoryId})`}
        pointerEvents="none" />
    </G>
  )
}
